<template>
  <div class="filter flex">
    <li v-for="i in filter" class="flex0" :class="[current==i.id&&showTag?'curr':'']" @click="showM(i.id)">
      <span v-if="i.id==='hos'">{{hosText}}<font class="iconfont">&#xe72c;</font></span>
      <span v-if="i.id==='dept'">{{deptText}}<font class="iconfont">&#xe72c;</font></span>
      <span v-if="i.id==='type'">{{typeText}}<font class="iconfont">&#xe72c;</font></span>
      <span v-if="i.id==='sort'">{{sortText}}<font class="iconfont">&#xe72c;</font></span>
    </li>
    <transition name="fade">
      <div v-if="showTag" class="mask fixed overflow-hidden overflow-touch" @click.stop="hide">
        <div class="item hoswrap overflow-y-auto overflow-touch" v-if="current=='hos'">
          <dl class="bg_white">
            <dd class="center" @click.stop="handler('hos','')">全部医院</dd>
            <dd v-for="o in hos" class="center" @click.stop="handler('hos',o.hosId)">{{o.hosName}}</dd>
          </dl>
        </div>

        <div class="item flex bg_white deptWrap" v-if="current=='dept'">
          <dl class="flex0 gb overflow-y-auto overflow-touch">
            <dd :class="[currdept===i?'curr':'']" v-for="(o,i) in dept" @click.stop="currdept=i">{{o.gbDeptName}}</dd>
          </dl>
          <dl class="flex1 son overflow-y-auto overflow-touch">
            <dd @click.stop="handler('dept',o.gbDeptCode)" v-for="o in sons">{{o.gbDeptName}}</dd>
          </dl>
        </div>

        <div class="item" v-if="current=='type'">
          <dl class="bg_white">
            <dd v-for="o in type" class="center" @click.stop="handler('type',o.id)">{{o.name}}</dd>
          </dl>
        </div>

        <div class="item" v-if="current=='sort'">
          <dl class="bg_white">
            <dd v-for="o in sort" class="center" @click.stop="handler('sort',o.id)">{{o.name}}</dd>
          </dl>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {DOC_FILTER} from "../../lib/config";
  import {str_substr} from "../../lib/filter";
  import * as R from 'ramda'

  export default {
    data() {
      return {
        showTag: false, filter: DOC_FILTER,
        current: '', currdept: 0, currhos: '', currtype: '', currsort: '',
        hos: [], dept: [], type: [], sort: [],
        form: {}
      };
    },
    computed: {
      sons() {
        let {dept, currdept} = this;
        let son;
        if (dept) {
          son = dept[currdept];
          if (son.sonGbDeptList && son.sonGbDeptList.length) {
            return son.sonGbDeptList;
          } else {
            return [{...son}]
          }
        }
        /*else if (dept) {
                 return R.chain(r => r.sonGbDeptList ? r.sonGbDeptList : [])(dept);
               }*/
        return [];
      },
      hosText() {
        if (!this.currhos) return "全部医院";
        let name = this.hos.find(r => r.hosId == this.currhos)['hosName'];
        return name.length > 4 ? str_substr(name, 3) : name;
      },
      deptText() {
        if (!this.form.dept) return '全部科室';
        let name = R.chain(r => r.sonGbDeptList ? r.sonGbDeptList : [r])(this.dept).find(r => r.gbDeptCode == this.form.dept)['gbDeptName'];
        return name.length > 4 ? str_substr(name, 3) : name;
      },
      typeText() {
        if (!this.currtype) return "全部形式";
        return this.type.find(r => r.id == this.currtype)['name'];
      },
      sortText() {
        if (!this.currsort) return "默认排序";
        return this.sort.find(r => r.id == this.currsort)['name'];
      },
    },
    components: {},
    mixins: [],
    async created() {
      await this.getHos();
      await this.getDept();
      this.getSort();
      this.getType();
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
      handler(type, id) {
        this.hide();
        (type !== 'dept') && this.$set(this.$data, `curr${type}`, id);
        this.$set(this.form, type, id);
        this.$emit('change', this.form);
      },

      showM(type) {
        if (this.showTag) {
          if (this.current != type) this.current = type;
          else this.showTag = false;
        } else {
          this.current = type;
          this.showTag = true;
        }
      },
      show() {
        this.showTag = true;
      },

      hide() {
        this.showTag = false;
      },

      getType() {
        this.type = [
          {id: '', name: '全部形式'},
          {id: 'Pic', name: '图文咨询'},
          {id: 'Video', name: '视频咨询'},
        ]
      },
      getSort() {
        this.sort = [
          {id: '', name: '默认排序'},
          {id: 'docScoure', name: '按好评排'},
        ]
      },
      async getDept() {
        let {code, list} = await this.$http('nethos.system.gbdept.list', {})
        list.unshift({"gbDeptCode": "00", "gbDeptName": "全部科室"});
        if (code == 0) this.dept = list;
        /*{"code":"0","list":[{"gbDeptCode":"01","gbDeptName":"预防保健科","superGbDeptCode":""},{"gbDeptCode":"02","gbDeptName":"全科医疗科"},{"gbDeptCode":"03","gbDeptName":"内科","sonGbDeptList":[{"gbDeptCode":"03.01","gbDeptName":"呼吸内科","superGbDeptCode":"03"},{"gbDeptCode":"03.02","gbDeptName":"消化内科","superGbDeptCode":"03"},{"gbDeptCode":"03.03","gbDeptName":"神经内科","superGbDeptCode":"03"},{"gbDeptCode":"03.04","gbDeptName":"心血管内科","superGbDeptCode":"03"},{"gbDeptCode":"03.05","gbDeptName":"血液内科","superGbDeptCode":"03"},{"gbDeptCode":"03.06","gbDeptName":"肾病学专业","superGbDeptCode":"03"},{"gbDeptCode":"03.07","gbDeptName":"内分泌科","superGbDeptCode":"03"},{"gbDeptCode":"03.08","gbDeptName":"风湿免疫科","superGbDeptCode":"03"},{"gbDeptCode":"03.09","gbDeptName":"变态反应（过敏）科","superGbDeptCode":"03"}]},{"gbDeptCode":"04","gbDeptName":"外科","sonGbDeptList":[{"gbDeptCode":"04.01","gbDeptName":"普外科","superGbDeptCode":"04"},{"gbDeptCode":"04.02","gbDeptName":"神经外科","superGbDeptCode":"04"},{"gbDeptCode":"04.03","gbDeptName":"骨科","superGbDeptCode":"04"},{"gbDeptCode":"04.04","gbDeptName":"泌尿外科","superGbDeptCode":"04"},{"gbDeptCode":"04.05","gbDeptName":"胸外科","superGbDeptCode":"04"},{"gbDeptCode":"04.06","gbDeptName":"心脏大血管外科","superGbDeptCode":"04"},{"gbDeptCode":"04.07","gbDeptName":"烧伤科","superGbDeptCode":"04"},{"gbDeptCode":"04.08","gbDeptName":"整形外科","superGbDeptCode":"04"},{"gbDeptCode":"04.09","gbDeptName":"其他","superGbDeptCode":"04"}]},{"gbDeptCode":"05","gbDeptName":"妇产科","sonGbDeptList":[{"gbDeptCode":"05.01","gbDeptName":"妇科","superGbDeptCode":"05"},{"gbDeptCode":"05.02","gbDeptName":"产科","superGbDeptCode":"05"},{"gbDeptCode":"05.03","gbDeptName":"生殖医学科","superGbDeptCode":"05"}]},{"gbDeptCode":"06","gbDeptName":"妇女保健科"},{"gbDeptCode":"07","gbDeptName":"儿科"},{"gbDeptCode":"09","gbDeptName":"儿童保健科"},{"gbDeptCode":"10","gbDeptName":"眼科"},{"gbDeptCode":"11","gbDeptName":"耳鼻咽喉科"},{"gbDeptCode":"12","gbDeptName":"口腔科","sonGbDeptList":[{"gbDeptCode":"12.05","gbDeptName":"口腔颌面外科","superGbDeptCode":"12"},{"gbDeptCode":"12.07","gbDeptName":"口腔正畸","superGbDeptCode":"12"},{"gbDeptCode":"12.13","gbDeptName":"其他","superGbDeptCode":"12"}]},{"gbDeptCode":"13","gbDeptName":"皮肤科"},{"gbDeptCode":"14","gbDeptName":"医疗美容科"},{"gbDeptCode":"15","gbDeptName":"精神科"},{"gbDeptCode":"16","gbDeptName":"传染科"},{"gbDeptCode":"19","gbDeptName":"肿瘤科"},{"gbDeptCode":"20","gbDeptName":"急诊医学科"},{"gbDeptCode":"21","gbDeptName":"康复医学科"},{"gbDeptCode":"26","gbDeptName":"麻醉科"},{"gbDeptCode":"27","gbDeptName":"疼痛科"},{"gbDeptCode":"28","gbDeptName":"重症医学科"},{"gbDeptCode":"31","gbDeptName":"病理科"},{"gbDeptCode":"32","gbDeptName":"医学影像科","sonGbDeptList":[{"gbDeptCode":"32.01","gbDeptName":"X线诊断专业","superGbDeptCode":"32"},{"gbDeptCode":"32.02","gbDeptName":"CT诊断专业","superGbDeptCode":"32"},{"gbDeptCode":"32.04","gbDeptName":"核医学专业","superGbDeptCode":"32"},{"gbDeptCode":"32.05","gbDeptName":"超声诊断专业","superGbDeptCode":"32"},{"gbDeptCode":"32.06","gbDeptName":"心电诊断专业","superGbDeptCode":"32"},{"gbDeptCode":"32.07","gbDeptName":"脑电及脑血流图诊断专业","superGbDeptCode":"32"},{"gbDeptCode":"32.09","gbDeptName":"介入放射学专业","superGbDeptCode":"32"},{"gbDeptCode":"32.10","gbDeptName":"放射治疗专业","superGbDeptCode":"32"}]},{"gbDeptCode":"50","gbDeptName":"中医科"},{"gbDeptCode":"52","gbDeptName":"中西医结合科"},{"gbDeptCode":"61","gbDeptName":"重症监护室(综合)"},{"gbDeptCode":"79","gbDeptName":"其它"},{"gbDeptCode":"80","gbDeptName":"专科护理"},{"gbDeptCode":"90","gbDeptName":"药剂科"},{"gbDeptCode":"99","gbDeptName":"管理科室","sonGbDeptList":[{"gbDeptCode":"99.01","gbDeptName":"感染(管理)科","superGbDeptCode":"99"}]}],"succ":true}*/
      },
      async getHos() {
        let {code, list} = await this.$http('nethos.doc.hos.list', {});
        if (code == 0) this.hos = list;
        /*{"code":"0","list":[{"hosId":"5940abe2e4b055746eab6f56","hosName":"浙医二院"},{"hosId":"59472e39e4b002cbff70c483","hosName":"长兴县人民医院"},{"hosId":"5a546eede4b0687fa734b84c","hosName":"杭州市上城区湖滨街道社区卫生服务中心"},{"hosId":"5a54705ae4b0687fa734b851","hosName":"杭州市上城区南星街道社区卫生服务中心"},{"hosId":"5a54716ee4b0687fa734b854","hosName":"杭州市上城区清波街道社区卫生服务中心"},{"hosId":"5a5471a7e4b0687fa734b857","hosName":"杭州市上城区望江街道社区卫生服务中心"},{"hosId":"5a5471cbe4b0687fa734b858","hosName":"杭州市上城区小营街道社区卫生服务中心"},{"hosId":"5a5471ebe4b0687fa734b859","hosName":"杭州市上城区紫阳街道社区卫生服务中心"},{"hosId":"5a603fd9e4b0687fa734c42a","hosName":"浙报医务室"},{"hosId":"5a603ff9e4b0687fa734c42b","hosName":"特扬医院"},{"hosId":"5a72c3dfe4b08695b9eb4d83","hosName":"遂昌县中医院"},{"hosId":"5ab9f849e4b077c285940ddb","hosName":"龙泉市人民医院"},{"hosId":"5ad0121ce4b0303fb4330570","hosName":"丽水市人民医院"},{"hosId":"5ad9958be4b0303fb433186c","hosName":"台州市立医院"},{"hosId":"5ae298e0e4b0303fb4332c1b","hosName":"湖州市妇幼保健院"},{"hosId":"5ae2ca5ee4b090753de16e06","hosName":"湖州市南浔区菱湖人民医院"},{"hosId":"5ae92aede4b090753de17834","hosName":"长兴县小浦镇卫生院"}],"succ":true}*/
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "../../common/public";

  span, font {
    color: #999999;
  }

  li {
    font-size: 14px;
    text-align: center;
    width: (100% / 4);
    @include h_lh(45px);

    font {
      display: inline-block;
      transition: all 0.3s;
    }

    &.curr {
      span, font {
        color: $mainColor;
      }
      font {
        transform: rotate(-180deg);
      }
    }
  }

  li + li {
    @include border(left);
  }

  .mask {
    overflow: hidden;
    @include t_r_b_l(1);
    z-index: 10000;
    top: 45px * 3;
    background-color: rgba(0, 0, 0, .5);
  }

  dd {
    @include h_lh(45px);
    &.curr {
      color: $mainColor;
      font {
        color: $mainColor;
      }
    }
  }

  dd + dd {
    @include border(top);
  }

  .deptWrap {
    @include border(left);
    &:after {
      left: 140px;
    }
    height: calc(100vh - 135px - 90px);
    overflow: hidden;
    dd {
      padding-left: 10px;
    }
    .gb {
      width: 140px;
    }
  }

  .hoswrap {
    max-height: calc(100vh - 135px);
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    bottom: calc(100vh - 135px);
  }
</style>



// WEBPACK FOOTER //
// src/plugins/consult/filter.vue